<app-notification-layout
  [desktopImageSrc]="'Icono-falla.png'"
  [mobileImageSrc]="'Icono-falla.png'"
  [title]="' Algo no cuadra...'"
>
  <div class="flex-1 flex flex-col gap-1 justify-even items-center mt-14">
    <p>
      Tus datos no pasaron la validación. Inténtalo otra vez, que aquí seguimos.
    </p>
    <div class="flex gap-4 mt-4 p-8">
      <button
        routerLink="/activate-form"
        class="bg-white w-[169px] h-[51px] text-[15px] uppercase text-red-500 border rounded-full p-4 font-extrabold text-xl mt-10"
      >
        Reintentar
      </button>
    </div>
  </div>
</app-notification-layout>
